import axios from '@/common/axios'
import qs from 'qs'

// 备案列表
export function getFilingList (params) {
  return axios({
    method: 'get',
    url: '/filing/list',
    params
  })
}

// 备案导出
export function filingOutput (query) {
  return axios({
    method: 'get',
    url: '/filing/output',
    responseType: "blob",
    params: query,
  })
}


// 预约申请列表
export function getVisitApply(params) {
  return axios({
    method: 'get',
    url: '/visitApply/list',
    params
  })
}

// 预约申请审批
export function approvalVisitApply(data) {
  return axios({
    method: "post",
    url: "/visitApply/approval",
    data: qs.stringify(data),
  });
}

// 预约申请导出
export function visitOutput(query) {
  return axios({
    method: 'get',
    url: '/visitApply/output',
    responseType: "blob",
    params: query,
  })
}